import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GoogleAnalyticsService } from '@services/google-analytics.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	standalone: false
})
export class AppComponent {
	title = 'Rem Latam';

	constructor(
		translate: TranslateService,
		googleAnalytics: GoogleAnalyticsService
	) {
		translate.addLangs(['en', 'es', 'pt']);
		translate.setDefaultLang('en');
		translate.use('en');
		googleAnalytics.init();
	}
}
